<div class="overlay-container py-2 fx-column fx-gap-sm">

  @if (contactInfo$ | async; as contacts) {
    @if (!isCollapsed) {
      <div class="row justify-content-center">
        <span class="mat-caption text-bold">Have a question about this order?</span>
      </div>
    }
    @if (isDetailExpand) {
      <div class="row justify-content-center">
        <div class="detail-section">
          <span class="font-weight-bold">Questions about your order?</span>
          <span class="detai-inline">Contact the {{ brandService.applicationName() }} Team at {{genericCoordinator.phoneNumber}}@if (genericCoordinator.email) {
            <span>or {{genericCoordinator.email}}</span>
          }</span>
        </div>
        @if (!isDetailExpand) {
          <div class="row m-0 justify-content-center">
            <span class="text-center">Contact: </span>
          </div>
        }
      </div>
    }
    <!-- Agent Display -->
    @if (showAgent && contacts.agent?._id) {
      <ng-container [ngTemplateOutlet]="contactInfo"
        [ngTemplateOutletContext]="{info:contacts.agent, index: 0}" />
    }
    <!-- CoLister Display -->
    @if (showCoLister && contacts.coListingAgent?._id) {
      @if (showAgent && contacts.agent?._id) {
        <mat-divider class="position-relative" />
      }
      <ng-container [ngTemplateOutlet]="contactInfo" [ngTemplateOutletContext]="{info:contacts.coListingAgent, index: 1}" />
    }
    <!--Team Member(s) Display-->
    @if (showTeam && contacts.team) {
      @if ((showAgent && contacts.agent?._id) || (showCoLister && contacts.coListingAgent?._id)) {
        <mat-divider class="position-relative" />
      }
      <ng-container [ngTemplateOutlet]="teamInfo" [ngTemplateOutletContext]="{info:contacts.team,agentId:contacts.agent?.userId}" />
    }
    <!-- Coordinator Display-->
    @if (showCoordinator) {
      @if (contacts.coordinator) {
        <ng-container [ngTemplateOutlet]="contactInfo"
          [ngTemplateOutletContext]="{info:contacts.coordinator, isCoordinator: true}" />
      } @else {
        <ng-container [ngTemplateOutlet]="contactInfo" [ngTemplateOutletContext]="{info:genericCoordinator}" />
      }
    }
  } @else {
    <div class="loading-overlay disabled">
      <mat-spinner [diameter]="24" />
    </div>
  }

  <!-- Template used to display contact info-->
  <ng-template #contactInfo let-info='info'>
    <div class="contact-info">
      <!-- Display contact details container-->
      @if (!isCollapsed && showCoordinator) {
        <ng-container [ngTemplateOutlet]="contactDetails"
          [ngTemplateOutletContext]="{info:info}" />
      }
      @if (!isCollapsed && !showCoordinator) {
        <ng-container [ngTemplateOutlet]="contactDetailsHorz"
          [ngTemplateOutletContext]="{info:info}" />
      }
      @if (isCollapsed && showCoordinator) {
        <ng-container [ngTemplateOutlet]="contactDetailsCollapsed"
          [ngTemplateOutletContext]="{info:info}" />
      }
    </div>
  </ng-template>

  <ng-template #contactDetails let-info="info"
    let-primaryAgent="primaryAgent"
    >
    <div class="fx-column">
      <!-- Display Profile photo -->
      @if (info) {
        <div class="row m-0 justify-content-center py-2">
          <lc-avatar [isVip]="info.isVipProfile" [photoUrl]="info?.profilePhotoUrl || info?.photoUrl" />
        </div>
      }

      <div class="row m-0 justify-content-center">
        <span class="text-center full-name overflow-ellipsis mat-body-2" title="{{info?.firstName}} {{info?.lastName}}">{{info?.firstName}} {{info?.lastName}}</span>
      </div>

      @if (info._id && info.phoneNumber) {
        <div class="row m-0 justify-content-center">
          <span class="text-center phone overflow-ellipsis mat-caption" title="{{ info?.phoneNumber | phone }}">{{ info?.phoneNumber | phone }} </span>
        </div>
      }

      @if (info._id && info.email) {
        <div class="row m-0 justify-content-center">
          <span class="text-center email overflow-ellipsis mat-caption" title="{{info?.email}}">{{ info?.email }} </span>
        </div>
      }

      @if (info._id && info.officeName && info.userId===primaryAgent) {
        <div class="row m-0 justify-content-center">
          <span class="text-center email overflow-ellipsis mat-caption" title="{{info?.officeName}}">{{ info?.officeName }} </span>
        </div>
      }

      @if (showCoordinator && info) {
        <div class="row m-0 justify-content-center">
          <span class="text-center generic-phone overflow-ellipsis mat-caption">{{genericCoordinator.phoneNumber}}</span>
        </div>
      }

      @if (!info._id || (showCoordinator && !info.email)) {
        <div class="row m-0 justify-content-center">
          <span class="text-center generic-email overflow-ellipsis mat-caption">{{genericCoordinator.email}}</span>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #contactDetailsCollapsed let-info="info">
    <!-- Display Profile photo -->
    @if (info) {
      <div class="row m-0 justify-content-center py-2">
        <lc-avatar [isVip]="info.isVipProfile" [photoUrl]="info?.profilePhotoUrl || info?.photoUrl" />
      </div>
    }

  </ng-template>

  <ng-template #contactDetailsHorz let-info="info" let-primaryagent="primaryAgent">
    <div class="member-wrapper">
      <!-- Display Profile photo -->
      <div class="member-avatar justify-content-center">
        <lc-avatar [isVip]="info.isVipProfile" [photoUrl]="info?.profilePhotoUrl || info?.photoUrl" />
      </div>
      <div class="member-data">
        <div class="full-name overflow-ellipsis mat-body-2" title="{{info?.firstName}} {{info?.lastName}}">{{info.firstName}} {{info.lastName}}</div>
        <div class="phone text-faded overflow-ellipsis mat-caption" title="{{ info?.phoneNumber | phone }}">{{info.phoneNumber | phone }}</div>
        <div class="metro text-faded overflow-ellipsis mat-caption" title="{{info?.metroName}}">{{info.metroName}}</div>
        <div class="member-email email text-faded overflow-ellipsis mat-caption" title="{{info?.email}}">{{info.email}}</div>
        @if (!primaryagent) {
          <div class="office-name text-faded overflow-ellipsis mat-caption" title="{{info?.officeName}}">{{info?.officeName}}</div>
        }
        <!-- Display primary agent office name during team members display -->
        @if ((primaryagent === info?.userId)) {
          <div class="office-name text-faded overflow-ellipsis mat-caption" title="{{info?.officeName}}">{{info.officeName}}</div>
        }
      </div>
      <a class="xs member-edit" lcTestId mat-icon-button
        [queryParams]="{ userId: info.userId }" [routerLink]="['/manage-order/' + marketingOrder?._id + '/profile/' + info?._id]">
        <mat-icon>edit</mat-icon>
      </a>
    </div>
  </ng-template>

  <!-- Template used to display team-->
  <ng-template #teamInfo let-agentId="agentId" let-info='info'>
    <div class="team-info fx-column fx-gap-sm">
      <!-- Display contact details container-->
      @if (!isCollapsed) {
        <ng-container [ngTemplateOutlet]="teamDetails" [ngTemplateOutletContext]="{info:info,agentId:agentId}" />
      }
    </div>
  </ng-template>

  <!-- Used to show team details-->
  <ng-template #teamDetails let-agentId="agentId" let-info="info">
    <div class="mx-1 fx-row x-space-between">
      <!-- Team Contact Information-->
      <div class="team-contact fx-column">
        <span class="text-left font-weight-bold full-name overflow-ellipsis mat-body-2" title="{{info?.name}}">{{info?.name}}</span>
        <span class="text-left phone overflow-ellipsis mat-caption" title="{{ info?.phoneNumber | phone }}">{{ info?.phoneNumber| phone }} </span>
        @if (info.email) {
          <span class="text-left email overflow-ellipsis mat-caption" title="{{info?.email}}">{{ info?.email }} </span>
        }
      </div>

      <!-- Edit Team button -->
      <a class="xs team-edit" lcTestId mat-icon-button [queryParams]="{agentId:agentId}" [routerLink]="['/manage-order/' + marketingOrder?._id + '/team/'+ info?.id]">
        <mat-icon>edit</mat-icon>
      </a>
    </div>
    <div class="row my-2 m-0 pull-left">
      <span class="mat-body-2 text-bold">Members: </span>
    </div>
    @for (aMember of info?.members; track aMember; let isLast = $last; let i = $index) {
      <div class="contact-info">
        <ng-container [ngTemplateOutlet]="contactDetailsHorz" [ngTemplateOutletContext]="{info:aMember,primaryAgent:agentId}" />
      </div>
      @if (!isLast) {
        <mat-divider class="position-relative" />
      }
    }
  </ng-template>
</div>
